import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';

export const MiniInventoryMap = {
  view_mini_inventory_filters: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    'view_mini-inventory-filters'
  ),
  view_vin_preview: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_VIN_DETAILS,
    TrackingConstant.VIEW_VIN_PREVIEW
  ),
  show_more_mini_inventory: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    'show_more_mini_inventory'
  ),
  mini_inventory_srp_link: TrackingEvent.actionCompleted(
    TrackingConstant.VIEW_SEARCH_RESULT,
    'mini_inventory_srp_link'
  ),
};
